<ng-container *ngIf="buttonModel">
    <ng-container *ngIf="isLabelButton(); then labeledButton else iconButton"></ng-container>
</ng-container>
<ng-template #labeledButton>
    <div [matTooltip]="getTooltip() | translate">
        <button mat-button
                *mxRestrict="buttonModel.permission"
                disableRipple="true"
                [name]="buttonModel.name"
                type="button"
                class="mxs-button"
                [ngClass]="buttonModel.className"
                [color]="buttonModel.color"
                [disabled]="getDisabled()"
                [hidden]="getHidden()"
                (click)="onClick()"
                [attr.data-icon]="buttonModel.icon">
            <i *ngIf="buttonModel.icon" class="material-icons">{{buttonModel.icon}}</i>
            {{ getLabel() | translate}}
        </button>
    </div>
</ng-template>

<ng-template #iconButton>
    <div [matTooltip]="getTooltip() | translate">
        <button mat-icon-button
                *mxRestrict="buttonModel.permission"
                disableRipple="true"
                [name]="buttonModel.name"
                type="button"
                class="mxs-button"
                [ngClass]="buttonModel.className"
                [color]="buttonModel.color"
                [disabled]="getDisabled()"
                [hidden]="getHidden()"
                (click)="onClick()"
                [attr.data-icon]="buttonModel.icon">
                    <i *ngIf="buttonModel.icon" class="material-icons">{{buttonModel.icon}}</i>
        </button>
    </div>
</ng-template>
